import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PositiveNumberValidator {
  static isPositive(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Let required/isNumber handle empty & non-numeric; only judge presence here
      if (control.value === null || control.value === undefined || control.value === '') {
        return null;
      }

      const numberValue = Number(control.value);

      // Not a finite number, or <= 0 → invalid
      return Number.isFinite(numberValue) && numberValue > 0 ? null : { notPositive: true };
    };
  }
}
